import { Col, Row } from "react-bootstrap";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { BsChevronDown } from "react-icons/bs";
import moment from "moment";
import Button from "../../../common/components/Button";
import ModalUpdateSurvey from "./ModalUpdateSurvey";
import { useState } from "react";

function SurveyColumn({
  surveys,
  handleApproveRejectSurvey,
  handleUpdateSurvey,
  loadingActions,
}) {
  const [show, setShow] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);

  const toggleShow = () => {
    setShow(prev => !prev);
  }

  const getSurveyStatus = (survey) => {
    if (survey?.oldEstado === "advertencia") {
      return { color: "#f58b84", label: "Advertencia" };
    }

    if (survey.estado === "aprobado") {
      return survey.completo === true || survey.completo === undefined
        ? { color: "#a8f584", label: "Aprobado" }
        : { color: "#f9f65b", label: "En proceso" };
    }

    if (survey.estado === "en proceso") {
      return { color: "#f9f65b", label: "En proceso" };
    }

    return { color: "#f58b84", label: "Advertencia" };
  };

  return (
    <Col xs={12} md={6} className="g-2">
      {surveys.map((survey) => {
        const status = getSurveyStatus(survey);
        const respuestas = survey.respuestas || [];

        return (
          <div key={survey.consecutivo_encuesta} className="col mb-1">
            <Accordion>
              <AccordionSummary
                expandIcon={<BsChevronDown />}
                sx={{
                  backgroundColor: status.color,
                }}
              >
                <div className="d-flex justify-content-between w-100 px-2 flex-wrap flex-lg-nowrap">
                  <Typography
                    fontSize={14}
                    sx={{ width: { xs: "100%", md: "20%" }, flexShrink: 0 }}
                  >
                    {moment(survey.fecha).format("YYYY-MM-DD")} {survey.consecutivo_encuesta}
                  </Typography>
                  <Typography
                    fontSize={14}
                    sx={{ width: { xs: "100%", md: "40%" }, flexShrink: 0 }}
                  >
                    {survey.nombre}
                  </Typography>
                  <Typography
                    fontSize={14}
                    sx={{ width: { xs: "100%", md: "25%" }, flexShrink: 0 }}
                  >
                    {moment(survey.fecha).isSameOrAfter("2024-11-28")
                      ? survey.placa
                      : survey.cedula}
                  </Typography>
                  <Typography
                    fontSize={14}
                    sx={{ width: { xs: "100%", md: "15%" }, flexShrink: 0 }}
                  >
                    {status.label}
                  </Typography>
                </div>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#f5f5f5" }}>
                <Row xs={1} md={3} lg={4}>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Fecha
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {moment(survey.fecha).format("YYYY-MM-DD")}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Estado
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.estado}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Celular
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.celular}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Nombre
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.nombre}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Cedula
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.cedula}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Placa
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.placa}
                    </Typography>
                  </Col>
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Kilometraje
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.kilometraje}
                    </Typography>
                  </Col>
                  {respuestas
                    .filter((res) => res.id_pregunta > 0)
                    .map((res, i) => (
                      <Col key={i} className="mb-3">
                        <Typography
                          sx={{ color: "text.secondary", fontSize: 14 }}
                        >
                          {res.pregunta}
                        </Typography>
                        <Typography
                          sx={{ color: "text.primary", fontSize: 14 }}
                        >
                          {res.traduccion_respuesta || res.respuesta || "-"}
                        </Typography>
                        <Typography
                          sx={{ color: "text.primary", fontSize: 14 }}
                        >
                          
                        </Typography>
                        {
                          res.tipo_respuesta === "SiNo"
                          ? 
                            res.respuesta &&
                            res.respuesta === res.respuesta_correcta
                            ? 
                              <Typography
                                sx={{ color: "green", fontSize: 14 }}
                              >
                                CORRECTA
                              </Typography>
                            : 
                              <Typography
                                sx={{ color: "red", fontSize: 14 }}
                              >
                                INCORRECTA
                              </Typography>
                          : ""}
                      </Col>
                    ))}
                  <Col className="mb-3">
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                      Completado
                    </Typography>
                    <Typography sx={{ color: "text.primary", fontSize: 14 }}>
                      {survey.completado ? "Sí" : "No"}
                    </Typography>
                  </Col>
                </Row>
              </AccordionDetails>
              <AccordionActions>
                <div className="d-flex gap-2 justify-content-end">
                  <Button loading={loadingActions} onClick={() => {
                    setSelectedSurvey(survey);
                    toggleShow();
                  }} color="#007bff">
                    Modificar
                  </Button>
                  <Button loading={loadingActions} onClick={() => handleApproveRejectSurvey(survey)}>
                    Aprobar/Rechazar
                  </Button>
                </div>
              </AccordionActions>
            </Accordion>
          </div>
        );
      })}

      <ModalUpdateSurvey 
        show={show}
        toggleShow={toggleShow}
        survey={selectedSurvey}
        setSurvey={setSelectedSurvey}
        onUpdateSurvey={handleUpdateSurvey}
      />
    </Col>
  );
}

export default SurveyColumn;
